<!--  -->
<template>
  <div class="wrapper" ref="wrapper">
    <div class="header-wrapper">
      <div class="header">党员阵地</div>
      <div class="addManager">
        <Button class="bkcc-btn" @click="onadd">添加</Button>
        <Button class="bkcc-btn" @click="addReset">重置</Button>
        <Button class="bkcc-btn" @click="onmodify">确认修改</Button>
      </div>
    </div>
    <div class="content">
      <div class="search">
        <i-form ref="search" :model="query">
          <row :gutter="80">
            <i-col span="8">
              <form-item label="名称" prop="name">
                <i-input v-model="query.name" clearable placeholder="请输入名称"/>
              </form-item>
            </i-col>
            <i-col span="8">
              <form-item label="联系电话" prop="phone">
                <i-input v-model="query.phone" clearable placeholder="请输入联系电话"/>
              </form-item>
            </i-col>
            <i-col span="8">
              <FormItem label="地点">
                <div v-if="didian" class="address" @click="showmap()">{{ didian }}</div>
                <div v-else @click="showmap()" class="address address_nodata">请选择地点</div>
                <map-modal v-if="showMap" @confirm="getAddress" @cancel="showmap" :zuobiao="zuobiao"></map-modal>
              </FormItem>
            </i-col>

          </row>
        </i-form>
      </div>
      <div class="table-tabs">

        <div class="table-data">
          <i-table
            :columns="tableHeader"
            :border="true"
            :loading="isTableLoading"
            :data="tableData"
            stripe
            ref="table"
            @on-row-dblclick="handleClickDetail"
          >
          <template slot-scope="{ row, index }" slot="action">
            <span @click="handleClickDetail(row, 'onmodify')" class="action">[修改]</span>
            <Poptip
              confirm
              title="确认删除?"
              placement="left"
              @on-ok="handleClickDetail(row, 'del')"
            >
              <span class="action">[删除]</span>
            </Poptip>
          </template>
          </i-table>
          <div class="page">
            <page :total="total" @on-change="pageChange" show-total/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
  import mapModal from "../../../components/mapModal";
  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
      mapModal,
    },
    data() {
      //这里存放数据
      return {
        zuobiao: {},
        center: [116.66517, 39.90575],
        addressList: [], // 联想搜索 地址列表
        didian:"",
        lal:"",
        showMap: false,
        isJiedao:0,
        page:1,
        isTableLoading:false,
        query: {
          "name": "",
          "address": "",
          "lal": "",
          "phone": "",
          "communityId":Number(this.$store.state.streetorcommunityid),
          "id": ""
        },
        tableHeader: [
          {
            title: "名称",
            key: "name",
          },
          {
            title: "地址",
            key: "address"
          },
          {
            title: "联系方式",
            key: "phone"
          },
          {
            title: "经纬度",
            key: "lal",
          },
         {
            title: "操作",
            key: "op",
            slot: "action"
          }],
        tableData:[],
        total:0
      };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      handleClickDetail(item, type) {
        let that=this
        console.log(item, type);
        if (type == "onmodify") {
          // 修改
          console.log("onmodify", item.id);
          this.didian =item.address;
          this.query = {
            "name":item.name,
            "address":item.address,
            "lal":item.lal,
            "phone":item.phone,
            "communityId":Number(this.$store.state.streetorcommunityid),
            "id": item.id
          }

        } else if (type == "del") {
          console.log("del", item.id);
          let url = that.urlobj.getdeleteMemberPosition+item.id;
          that.isTableLoading = true;
          that.$post(url).then(res => {
            that.isTableLoading = false;
            if (res.isSucceed) {
              that.addReset()
            }
          }).catch(e=>{
            that.isTableLoading = false;
          })

        }
      },
      showmap() {
        this.showMap = !this.showMap;
      },
      getAddress(val) {
        console.log(val)
        this.zuobiao = val;
        this.query.lal=val.value;
        this.didian = val.label;
        this.query.address=val.label;
        this.showmap();
      },
      onadd(page){
       var that=this
       let url = that.urlobj.getinsertMemberPosition;
       console.log(that.query.id)
       if(that.query.id){
         this.$Message.success("请点击确认修改");
         return;
       }
       if(!that.query.name){
         this.$Message.success("请输入名称");
         return;
       }
       if(!that.query.phone){
         this.$Message.success("请输入联系电话");
         return;
       }
       if(!that.query.address){
         this.$Message.success("请选择地址");
         return;
       }
       that.query.id='';
       console.log(that.query)
       let data = {
         ...that.query
       };
       that.isTableLoading = true;
       that.$post(url, data).then(res => {
         that.isTableLoading = false;
         if (res.isSucceed) {
           that.addReset()
         }
       }).catch(e=>{
         that.isTableLoading = false;
       })
      },
      addReset(){
        //重置搜索条件
        this.query = {
          "name": "",
          "address": "",
          "lal": "",
          "phone": "",
          "communityId":Number(this.$store.state.streetorcommunityid),
          "id": ""
        }
        this.didian='';
        this.page = 1
        this.getList({communityId:Number(this.$store.state.streetorcommunityid)})
      },
      pageChange(val){
        //翻页
        this.page = val;
        this.getList({communityId:Number(this.$store.state.streetorcommunityid)})
      },
      onmodify(){
        console.log('onmodify')
        var that=this
        if(!that.query.id){
          this.$Message.success("请点击添加");
          return;
        }
        if(!that.query.name){
          this.$Message.success("请输入名称");
          return;
        }
        if(!that.query.phone){
          this.$Message.success("请输入联系电话");
          return;
        }
        if(!that.query.address){
          this.$Message.success("请选择地址");
          return;
        }

        let url = that.urlobj.getupdateMemberPosition;
        let data = {
          ...that.query
        };
        that.isTableLoading = true;
        that.$post(url, data).then(res => {
          that.isTableLoading = false;
          if (res.isSucceed) {

            that.addReset()
          }
        }).catch(e=>{
          that.isTableLoading = false;
        })
      },
      async getList(params){
        console.log('getList')
        //获取停车信息列表
        var that=this
        let url = that.urlobj.getselectMemberPosition+"pc";
        let data = {
          pageNum: that.page,
          pageSize: 10,
          ...params
        };
        console.log(that.$store.state.streetorcommunityid)
        that.isTableLoading = true;
        that.$post(url, data).then(res => {
          that.isTableLoading = false;
          console.log(res)
          if (res.isSucceed) {
            that.total = parseInt(res.total);
            that.tableData = res.rows

          }
        }).catch(e=>{
          that.isTableLoading = false;

        })
      },
    },

    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
      this.isJiedao = this.$store.state.isJiedao;
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.getList({communityId:Number(this.$store.state.streetorcommunityid)})
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>
<style lang='less' scoped>
  //@import url(); 引入公共css类
  .wrapper {
    color: #666666;
    overflow: hidden;
    height: 100%;
  }

  .wrapper::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    /* height: 4px; */
  }
  .header-wrapper {
    display: flex;
    justify-content: center;
    height: 84px;
    line-height: 84px;
    position: relative;
  }
  .header {
    font-size: 25px;
    text-align: center;
  }
  .addManager {
    position: absolute;
    right: 20px;
  }

  .content {
    //   @content();
    max-width: 96%;
    margin: 20px;
    margin-left: 40px;
    overflow: hidden;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .search {
    width: 100%;
    background-color: white;
    border-radius: 5px;
    padding: 20px;
  }
  .table-tabs {
    max-width: 100%;
    padding: 0;
    margin-top: 30px;

    /deep/ .ivu-tabs-bar {
      margin-bottom: 0;
      border-bottom: 0;
    }
    /deep/ .ivu-tabs-tab-active {
      color: white;
      background: #fe7d43;
      border-radius: 5px 5px 0 0;
    }
    /deep/ .ivu-tabs-ink-bar {
      height: 0px;
    }
    /deep/ .ivu-tabs-nav {
      padding-left: 10px;
      color: black;
    }
    /deep/ .ivu-table-tip {
      overflow-x: hidden
    }
  }
  .table-data {
    width: 100%;
    background-color: white;
    border-radius: 5px;
    padding: 20px;
    min-height: calc(100vh - 450px);
    .page {
      width: 100%;
      margin-top: 10px;
      display: flex;
      justify-content: flex-end;
    }
  }
  /*选择地点的样式*/
  .address {
    width: 100%;
    height: 34px;
    line-height: 24px;
    padding: 4px 7px;
    font-size: 12px;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    color: #515a6e;
    background-color: #fff;
    background-image: none;
    position: relative;
    cursor: text;
    margin-top: 34px;
  }
  .address_nodata {
    color: #bbb;
  }
  .address:hover {
    border: 1px solid #ff7b44;
  }
  .address:active {
    border: 1px solid #ff7b44;
  }
</style>
